import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sconf" }
const _hoisted_2 = { class: "sconf__main" }
const _hoisted_3 = {
  class: "sui-card",
  "data-tour": "seller-settings-profile"
}
const _hoisted_4 = { class: "sui-card__head" }
const _hoisted_5 = { class: "sui-card__body sconf__body" }
const _hoisted_6 = { class: "sui-row sconf__row" }
const _hoisted_7 = { class: "sui-field" }
const _hoisted_8 = { class: "sui-field" }
const _hoisted_9 = { class: "sui-row sconf__row" }
const _hoisted_10 = { class: "sui-field" }
const _hoisted_11 = { class: "sui-field" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "sui-row sconf__row" }
const _hoisted_14 = { class: "sui-field" }
const _hoisted_15 = { class: "sui-field" }
const _hoisted_16 = { class: "sui-row sconf__row" }
const _hoisted_17 = { class: "sui-field" }
const _hoisted_18 = { class: "sui-field" }
const _hoisted_19 = { class: "sconf__inline" }
const _hoisted_20 = ["value"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "sui-field" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "sui-field" }
const _hoisted_25 = {
  class: "sui-card",
  "data-tour": "seller-settings-bank"
}
const _hoisted_26 = { class: "sui-card__body sconf__body" }
const _hoisted_27 = { class: "sui-row sconf__row" }
const _hoisted_28 = { class: "sui-field" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "sui-field" }
const _hoisted_31 = { class: "sui-field" }
const _hoisted_32 = { class: "sconf__notice" }
const _hoisted_33 = {
  class: "sui-card",
  "data-tour": "seller-settings-shipping"
}
const _hoisted_34 = { class: "sui-card__body sconf__body" }
const _hoisted_35 = { class: "sui-row sconf__row" }
const _hoisted_36 = { class: "sui-field" }
const _hoisted_37 = { class: "sui-row sconf__row" }
const _hoisted_38 = { class: "sui-field" }
const _hoisted_39 = { class: "sui-field" }
const _hoisted_40 = {
  class: "sui-card",
  "data-tour": "seller-settings-notify"
}
const _hoisted_41 = { class: "sui-card__body" }
const _hoisted_42 = { class: "sconf__toggles" }
const _hoisted_43 = { class: "sconf__switch" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = {
  class: "sui-card",
  "data-tour": "seller-settings-contract"
}
const _hoisted_46 = { class: "sui-card__body sconf__body" }
const _hoisted_47 = {
  key: 0,
  class: "sconf__legal-empty"
}
const _hoisted_48 = {
  key: 1,
  class: "sconf__legal-empty"
}
const _hoisted_49 = {
  key: 2,
  class: "sconf__legal-empty"
}
const _hoisted_50 = {
  key: 0,
  class: "sconf__legal-note"
}
const _hoisted_51 = {
  key: 1,
  class: "sconf__legal-terms"
}
const _hoisted_52 = { class: "sconf__legal-head" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "sconf__legal-body" }
const _hoisted_55 = { class: "sconf__side" }
const _hoisted_56 = { class: "sui-card" }
const _hoisted_57 = { class: "sui-card__body" }
const _hoisted_58 = { class: "sconf__summary" }
const _hoisted_59 = { class: "sconf__actions" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "sui-card sconf__help" }
const _hoisted_62 = { class: "sui-card__body" }
const _hoisted_63 = { class: "sconf__help-contact" }
const _hoisted_64 = { class: "sconf__help-contact" }
const _hoisted_65 = {
  key: 0,
  class: "sui-toast"
}

import { computed, onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import ContractDocumentView from '@/components/seller/ContractDocumentView.vue'
import { downloadMyAcceptancePdf, fetchMyLegalAcceptances } from '@/api/seller'
import { useSellerProducts } from '@/composables/useSellerProducts'
import { useSellerAuth } from '@/composables/useSellerAuth'
import { useDaumPostcode } from '@/composables/useDaumPostcode'
import { MALL_BANKS } from '@/constants/banks'
import { SELLER_GRADE_LABEL, SELLER_STATUS_LABEL } from '@/constants/sellerSession'
import {
  downloadLegalText,
  mergeLegalDocViews,
  type LegalAcceptanceView,
} from '@/utils/legalAcceptancePreview'

const DEFAULT_POLICY =
  '상품 하자 · 오배송은 수령 후 7일 이내 무상 교환 · 반품이 가능합니다.\n단순 변심은 수령 후 7일 이내, 왕복 배송비 부담 조건으로 접수됩니다.\n개봉 · 사용 흔적이 있는 위생용품은 반품이 어렵습니다.'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerSettingsPage',
  setup(__props) {

const { products: liveProducts, load: loadLiveProducts } = useSellerProducts()
const { seller, isApproved, saveProfile } = useSellerAuth()
const toast = ref('')
let toastTimer: ReturnType<typeof setTimeout> | undefined

const legalViews = ref<LegalAcceptanceView[]>([])
const acceptsLoading = ref(false)
const acceptsError = ref('')
const contractViews = computed(() => legalViews.value.filter((row) => row.kind === 'CONTRACT'))
const termViews = computed(() => legalViews.value.filter((row) => row.kind !== 'CONTRACT'))

async function loadAcceptances() {
  acceptsLoading.value = true
  acceptsError.value = ''
  try {
    const { accepts, activeDocs } = await fetchMyLegalAcceptances()
    legalViews.value = mergeLegalDocViews(accepts, activeDocs)
  } catch (error) {
    legalViews.value = []
    acceptsError.value =
      error instanceof Error ? error.message : '계약·약관 내역을 불러오지 못했습니다.'
  } finally {
    acceptsLoading.value = false
  }
}

function downloadAcceptance(doc: LegalAcceptanceView) {
  downloadLegalText(doc)
}

onMounted(() => {
  void loadLiveProducts()
  void loadAcceptances()
})
const { opening: postcodeOpening, searchPostcode } = useDaumPostcode()

const BANKS = MALL_BANKS

const notifications = [
  { key: 'order' as const, label: '신규 주문', desc: '결제가 완료되면 등록한 이메일과 휴대폰으로 알립니다.' },
  { key: 'claim' as const, label: '취소 · 반품 요청', desc: '요청이 접수되면 등록한 이메일과 휴대폰으로 알립니다.' },
  { key: 'stock' as const, label: '재고 부족', desc: '메일·문자는 보내지 않습니다. 상품 화면에서 확인하세요.' },
  { key: 'inquiry' as const, label: '상품 문의', desc: '메일·문자는 보내지 않습니다. 문의 화면에서 확인하세요.' },
  { key: 'settlement' as const, label: '정산 지급', desc: '메일·문자는 보내지 않습니다. 정산 화면에서 확인하세요.' },
]

function initialForm() {
  const current = seller.value
  return {
    storeName: current?.storeName ?? '',
    ownerName: current?.ownerName ?? '',
    managerName: current?.managerName ?? '',
    bizName: current?.bizName ?? '',
    bizNumber: current?.bizNumber ?? '',
    phone: current?.phone ?? '',
    email: current?.email ?? '',
    zipcode: current?.zipcode ?? '',
    address: current?.address ?? '',
    addressDetail: current?.addressDetail ?? '',
    settleBank: current?.settleBank ?? '',
    settleAccount: current?.settleAccount ?? '',
    settleHolder: current?.settleHolder ?? '',
    shippingFee: current?.shippingFee ?? 3000,
    freeShipOver: 0,
    returnFee: current?.returnFee ?? 3000,
    cutoff: current?.cutoff || '14:00',
    returnPolicy: current?.returnPolicy || DEFAULT_POLICY,
    notify: {
      order: current?.notify?.order ?? true,
      claim: current?.notify?.claim ?? true,
      stock: current?.notify?.stock ?? true,
      inquiry: current?.notify?.inquiry ?? true,
      settlement: current?.notify?.settlement ?? false,
    },
  }
}

const form = ref(initialForm())
const saving = ref(false)

const registeredCount = computed(() => liveProducts.value.length)
const sellingCount = computed(
  () => liveProducts.value.filter((item) => item.status === 'SELLING').length,
)

function notify(message: string) {
  toast.value = message
  window.clearTimeout(toastTimer)
  toastTimer = setTimeout(() => {
    toast.value = ''
  }, 2400)
}
const statusLabel = computed(() =>
  seller.value ? SELLER_STATUS_LABEL[seller.value.status] : '확인 중',
)
const gradeLabel = computed(() => SELLER_GRADE_LABEL[seller.value?.grade ?? 'NORMAL'] ?? '일반')
const joinedAt = computed(() => (seller.value?.joinedAt ?? '').slice(0, 10) || '-')

async function onSave() {
  if (saving.value) {
    return
  }
  if (!window.confirm('변경 내용을 저장할까요?')) return

  saving.value = true

  try {
    await saveProfile({
      storeName: form.value.storeName,
      bizName: form.value.bizName,
      ownerName: form.value.ownerName,
      managerName: form.value.managerName,
      email: form.value.email,
      phone: form.value.phone,
      zipcode: form.value.zipcode,
      address: form.value.address,
      addressDetail: form.value.addressDetail,
      settleBank: form.value.settleBank,
      settleAccount: form.value.settleAccount,
      settleHolder: form.value.settleHolder,
      shippingFee: form.value.shippingFee,
      freeShipOver: 0,
      returnFee: form.value.returnFee,
      cutoff: form.value.cutoff,
      returnPolicy: form.value.returnPolicy,
      notify: { ...form.value.notify },
    })
    form.value = initialForm()
    notify('판매업체 정보를 저장했습니다.')
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '판매업체 정보 저장에 실패했습니다.')
  } finally {
    saving.value = false
  }
}

async function onSearchAddress() {
  try {
    const picked = await searchPostcode()
    if (!picked) {
      return
    }
    form.value.zipcode = picked.zipcode
    form.value.address = picked.extra ? `${picked.address} ${picked.extra}` : picked.address
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '주소 검색을 열지 못했습니다.')
  }
}

function onReset() {
  if (!window.confirm('작성 중인 변경 내용을 되돌릴까요?')) return
  form.value = initialForm()
  notify('변경 내용을 되돌렸습니다.')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "sui-card__title" }, "판매업체 정보", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(["sui-badge", _unref(isApproved) ? 'sui-badge--green' : 'sui-badge--amber'])
          }, [
            _createVNode(AppIcon, {
              icon: _unref(isApproved) ? 'mdi-shield-check' : 'mdi-clock-outline',
              size: 13
            }, null, 8, ["icon"]),
            _createTextVNode(" " + _toDisplayString(statusLabel.value), 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "c-store" }, "업체명", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-store",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.storeName) = $event)),
                class: "sui-input"
              }, null, 512), [
                [_vModelText, form.value.storeName]
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "sui-hint" }, "함우리몰 상품 목록과 주문서에 노출되는 이름입니다.", -1))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { for: "c-owner" }, "대표자명", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-owner",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.ownerName) = $event)),
                class: "sui-input"
              }, null, 512), [
                [_vModelText, form.value.ownerName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { for: "c-biz" }, "상호", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-biz",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.bizName) = $event)),
                class: "sui-input"
              }, null, 512), [
                [_vModelText, form.value.bizName]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { for: "c-bizno" }, "사업자등록번호", -1)),
              _createElementVNode("input", {
                id: "c-bizno",
                value: form.value.bizNumber,
                class: "sui-input",
                readonly: ""
              }, null, 8, _hoisted_12),
              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "sui-hint" }, "변경하려면 운영팀에 서류를 제출해야 합니다.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { for: "c-phone" }, "대표 연락처", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-phone",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.phone) = $event)),
                class: "sui-input"
              }, null, 512), [
                [_vModelText, form.value.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { for: "c-email" }, "담당자 이메일", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.email) = $event)),
                type: "email",
                class: "sui-input"
              }, null, 512), [
                [_vModelText, form.value.email]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { for: "c-manager" }, "담당자명", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-manager",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.managerName) = $event)),
                class: "sui-input"
              }, null, 512), [
                [_vModelText, form.value.managerName]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { for: "c-zip" }, "우편번호", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("input", {
                  id: "c-zip",
                  value: form.value.zipcode,
                  class: "sui-input",
                  readonly: "",
                  onClick: onSearchAddress
                }, null, 8, _hoisted_20),
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn",
                  disabled: _unref(postcodeOpening),
                  onClick: onSearchAddress
                }, " 주소 검색 ", 8, _hoisted_21)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { for: "c-addr" }, "출고지 주소", -1)),
            _createElementVNode("input", {
              id: "c-addr",
              value: form.value.address,
              class: "sui-input",
              placeholder: "주소 검색을 눌러 주세요",
              readonly: "",
              onClick: onSearchAddress
            }, null, 8, _hoisted_23)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { for: "c-addr2" }, "상세 주소", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "c-addr2",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.addressDetail) = $event)),
              class: "sui-input"
            }, null, 512), [
              [_vModelText, form.value.addressDetail]
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_25, [
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "sui-card__head" }, [
          _createElementVNode("h2", { class: "sui-card__title" }, "정산 계좌")
        ], -1)),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { for: "c-bank" }, "은행", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "c-bank",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.settleBank) = $event)),
                class: "sui-select sconf__select"
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("option", { value: "" }, "선택해 주세요", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BANKS), (bank) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: bank,
                    value: bank
                  }, _toDisplayString(bank), 9, _hoisted_29))
                }), 128))
              ], 512), [
                [_vModelSelect, form.value.settleBank]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { for: "c-acc" }, "계좌번호", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-acc",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.settleAccount) = $event)),
                class: "sui-input"
              }, null, 512), [
                [_vModelText, form.value.settleAccount]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { for: "c-holder" }, "예금주", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "c-holder",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.settleHolder) = $event)),
              class: "sui-input"
            }, null, 512), [
              [_vModelText, form.value.settleHolder]
            ])
          ]),
          _createElementVNode("p", _hoisted_32, [
            _createVNode(AppIcon, {
              icon: "mdi-information-outline",
              size: 16
            }),
            _cache[30] || (_cache[30] = _createTextVNode(" 예금주는 사업자등록증상 상호와 일치해야 합니다. 계좌를 바꾸면 다음 정산부터 반영됩니다. ", -1))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_33, [
        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "sui-card__head" }, [
          _createElementVNode("h2", { class: "sui-card__title" }, "배송 · 반품 정책")
        ], -1)),
        _createElementVNode("div", _hoisted_34, [
          _cache[37] || (_cache[37] = _createElementVNode("p", { class: "sconf__hint" }, " 고객에게는 출고 배송비를 따로 받지 않습니다. 배송비는 판매가격에 포함됩니다. 환불 배송비는 상품 등록에서 상품마다 정합니다. 기준 수량마다 한 번 받고, 수량이 넘치면 올림합니다. 교환안내는 스토어 공통으로 상품상세에 표시됩니다. 당일 출고 문구는 관리자 「화면 멘트」에서 정하며, 비우면 안내가 숨겨집니다. ", -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { for: "c-fee" }, "신규 상품 기본 배송비 (원)", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "c-fee",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.shippingFee) = $event)),
                type: "number",
                min: "0",
                class: "sui-input"
              }, null, 512), [
                [
                  _vModelText,
                  form.value.shippingFee,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("p", { class: "sui-hint" }, "0원이면 신규 상품이 무료 배송으로 시작합니다. 기존 상품은 상품 수정에서 바꾸세요.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { for: "c-cutoff" }, "당일 출고 마감", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "c-cutoff",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.cutoff) = $event)),
                class: "sui-select sconf__select"
              }, [...(_cache[34] || (_cache[34] = [
                _createElementVNode("option", { value: "12:00" }, "12시", -1),
                _createElementVNode("option", { value: "14:00" }, "14시", -1),
                _createElementVNode("option", { value: "16:00" }, "16시", -1)
              ]))], 512), [
                [_vModelSelect, form.value.cutoff]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { for: "c-policy" }, "교환 · 반품 안내", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "c-policy",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.returnPolicy) = $event)),
              class: "sui-input sconf__textarea",
              rows: "4"
            }, null, 512), [
              [_vModelText, form.value.returnPolicy]
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_40, [
        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "sui-card__head" }, [
          _createElementVNode("h2", { class: "sui-card__title" }, "알림 받기")
        ], -1)),
        _createElementVNode("div", _hoisted_41, [
          _cache[40] || (_cache[40] = _createElementVNode("p", { class: "sconf__hint" }, " 메일은 바로 손봐야 하는 일만 보냅니다. 신규 주문·취소/반품은 아래 스위치를 켠 경우 등록 이메일·휴대폰으로 가고, 가입 승인·반려·정지와 주문 취소는 스위치와 관계없이 이메일로 안내합니다. 재고·문의·정산은 판매관리센터에서 확인합니다. ", -1)),
          _createElementVNode("ul", _hoisted_42, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(notifications, (item) => {
              return _createElementVNode("li", {
                key: item.key
              }, [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(item.label), 1),
                  _createElementVNode("em", null, _toDisplayString(item.desc), 1)
                ]),
                _createElementVNode("label", _hoisted_43, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((form.value.notify[item.key]) = $event)
                  }, null, 8, _hoisted_44), [
                    [_vModelCheckbox, form.value.notify[item.key]]
                  ]),
                  _cache[39] || (_cache[39] = _createElementVNode("span", null, null, -1))
                ])
              ])
            }), 64))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_45, [
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "sui-card__head" }, [
          _createElementVNode("h2", { class: "sui-card__title" }, "계약 · 약관")
        ], -1)),
        _createElementVNode("div", _hoisted_46, [
          _cache[43] || (_cache[43] = _createElementVNode("p", { class: "sconf__hint" }, " 공급계약서와 이용약관 본문입니다. 서명 전이라도 활성 계약서를 확인할 수 있고, 온보딩 후에는 체결 버전과 서명이 함께 표시됩니다. ", -1)),
          (acceptsLoading.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_47, "불러오는 중…"))
            : (acceptsError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(acceptsError.value), 1))
              : (!legalViews.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_49, " 등록된 계약서·약관이 없습니다. 관리자에게 문의해 주세요. "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractViews.value, (doc) => {
                      return (_openBlock(), _createBlock(ContractDocumentView, {
                        key: `${doc.code}-${doc.version}-${doc.idx ?? 'active'}`,
                        mode: "view",
                        title: doc.title || doc.code,
                        version: doc.version,
                        body: doc.body || '',
                        signature: doc.signature || '',
                        "signed-at": doc.signedAt || '',
                        party: {
                storeName: form.value.storeName || form.value.bizName,
                ownerName: form.value.ownerName,
                bizNumber: form.value.bizNumber,
                address: form.value.address,
                addressDetail: form.value.addressDetail,
              },
                        "download-stored-pdf": 
                doc.hasPdf && doc.idx
                  ? () =>
                      _unref(downloadMyAcceptancePdf)(
                        doc.idx as number,
                        `${doc.title || doc.code}_v${doc.version}.pdf`,
                      )
                  : undefined
              
                      }, null, 8, ["title", "version", "body", "signature", "signed-at", "party", "download-stored-pdf"]))
                    }), 128)),
                    (contractViews.value.length && !contractViews.value.some((d) => d.signature || d.signedAt))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_50, " 아직 서명이 없습니다. 계약서 본문은 확인할 수 있습니다. "))
                      : _createCommentVNode("", true),
                    (termViews.value.length)
                      ? (_openBlock(), _createElementBlock("details", _hoisted_51, [
                          _createElementVNode("summary", null, "이용약관 " + _toDisplayString(termViews.value.length) + "건", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(termViews.value, (doc) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: `${doc.code}-${doc.version}-${doc.idx ?? 'active'}`,
                              class: "sconf__legal-doc"
                            }, [
                              _createElementVNode("header", _hoisted_52, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("strong", null, _toDisplayString(doc.title || doc.code), 1),
                                  _createElementVNode("em", null, " 이용약관 · " + _toDisplayString(doc.code) + " · v" + _toDisplayString(doc.version) + " · " + _toDisplayString(doc.signedAt || doc.signature ? `동의 ${doc.signedAt || '-'}` : '미서명 · 본문 열람'), 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sui-btn sui-btn--sm",
                                  onClick: ($event: any) => (downloadAcceptance(doc))
                                }, [
                                  _createVNode(AppIcon, {
                                    icon: "mdi-download",
                                    size: 16
                                  }),
                                  _cache[42] || (_cache[42] = _createTextVNode(" 텍스트 저장 ", -1))
                                ], 8, _hoisted_53)
                              ]),
                              _createElementVNode("pre", _hoisted_54, _toDisplayString(doc.body || '(본문 없음)'), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
        ])
      ])
    ]),
    _createElementVNode("aside", _hoisted_55, [
      _createElementVNode("section", _hoisted_56, [
        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "sui-card__head" }, [
          _createElementVNode("h2", { class: "sui-card__title" }, "업체 요약")
        ], -1)),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("dl", _hoisted_58, [
            _createElementVNode("div", null, [
              _cache[45] || (_cache[45] = _createElementVNode("dt", null, "업체 코드", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(seller)?.sellerCode || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[46] || (_cache[46] = _createElementVNode("dt", null, "가입일", -1)),
              _createElementVNode("dd", null, _toDisplayString(joinedAt.value), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[47] || (_cache[47] = _createElementVNode("dt", null, "등급", -1)),
              _createElementVNode("dd", null, _toDisplayString(gradeLabel.value), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[48] || (_cache[48] = _createElementVNode("dt", null, "판매 수수료", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(seller)?.feeRate ?? 0) + "%", 1)
            ]),
            _createElementVNode("div", null, [
              _cache[49] || (_cache[49] = _createElementVNode("dt", null, "등록 상품", -1)),
              _createElementVNode("dd", null, _toDisplayString(registeredCount.value) + "개", 1)
            ]),
            _createElementVNode("div", null, [
              _cache[50] || (_cache[50] = _createElementVNode("dt", null, "판매중", -1)),
              _createElementVNode("dd", null, _toDisplayString(sellingCount.value) + "개", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("button", {
              type: "button",
              class: "sui-btn sui-btn--primary sconf__save",
              "data-tour": "seller-settings-save",
              disabled: saving.value,
              onClick: onSave
            }, _toDisplayString(saving.value ? '저장 중...' : '변경 내용 저장'), 9, _hoisted_60),
            _createElementVNode("button", {
              type: "button",
              class: "sui-btn",
              onClick: onReset
            }, "되돌리기")
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _cache[54] || (_cache[54] = _createElementVNode("h3", null, "도움이 필요하신가요?", -1)),
          _cache[55] || (_cache[55] = _createElementVNode("p", null, "가입 · 정산 · 배송 관련 문의는 운영팀이 평일 09:00~18:00 응대합니다.", -1)),
          _createElementVNode("p", _hoisted_63, [
            _createVNode(AppIcon, {
              icon: "mdi-phone-outline",
              size: 16
            }),
            _cache[52] || (_cache[52] = _createTextVNode(" 1600-0000 ", -1))
          ]),
          _createElementVNode("p", _hoisted_64, [
            _createVNode(AppIcon, {
              icon: "mdi-email-outline",
              size: 16
            }),
            _cache[53] || (_cache[53] = _createTextVNode(" seller@hamwoori.kr ", -1))
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "sui-toast" }, {
      default: _withCtx(() => [
        (toast.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_65, [
              _createVNode(AppIcon, {
                icon: "mdi-check-circle",
                size: 18
              }),
              _createTextVNode(" " + _toDisplayString(toast.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})